import { useState } from 'react'
import { apiClient } from '../api/client'
import type { ParentCommentSyncResponse } from '../api/types'

type UseParentCommentSyncResult = {
  syncing: boolean
  syncError: string | null
  syncResult: ParentCommentSyncResponse | null
  sync: (startDate: string, endDate: string, onSuccess?: () => void) => Promise<void>
}

/**
 * 保護者連絡帳の同期アクションを管理するフック
 */
export function useParentCommentSync(): UseParentCommentSyncResult {
  const [syncing, setSyncing] = useState(false)
  const [syncError, setSyncError] = useState<string | null>(null)
  const [syncResult, setSyncResult] = useState<ParentCommentSyncResponse | null>(null)

  const sync = async (startDate: string, endDate: string, onSuccess?: () => void) => {
    setSyncing(true)
    setSyncError(null)
    setSyncResult(null)

    try {
      const result = await apiClient.syncParentComments({ startDate, endDate })
      setSyncResult(result)
      onSuccess?.()
    } catch (err) {
      const message = err instanceof Error ? err.message : '同期に失敗しました'
      setSyncError(message)
    } finally {
      setSyncing(false)
    }
  }

  return {
    syncing,
    syncError,
    syncResult,
    sync,
  }
}
